import { Clock, Shield, Sparkle } from '@phosphor-icons/react';

import { AuthBrand } from './AuthBrand';
import pt from '../../locales/pt';
import { cn } from '../../utils/cn';

const ICONS = {
  shield: Shield,
  clock: Clock,
  sparkle: Sparkle,
};

/**
 * Marketing panel for tablet/desktop auth split — .pen aside.
 * @param {'signIn' | 'signUp'} mode
 */
export function AuthAside({ mode = 'signUp', className }) {
  const copy = pt.auth.aside[mode];

  return (
    <aside
      className={cn(
        'flex flex-col bg-gradient-to-br from-sage-gradient-hero-from to-sage-gradient-hero-to px-space-8 py-space-10 text-white',
        className,
      )}
      data-testid="auth-aside"
    >
      <AuthBrand to="/" tone="onSage" />
      <div className="mt-auto flex flex-col gap-space-6">
        <h2 className="type-landing-h2 text-white">
          {copy.headline}
        </h2>
        <ul className="flex flex-col gap-space-4">
          {copy.benefits.map((ben) => {
            const Icon = ICONS[ben.icon] || Shield;
            return (
              <li key={ben.title} className="flex gap-space-3">
                <span className="flex size-[34px] shrink-0 items-center justify-center rounded-ds-md bg-white/15">
                  <Icon className="size-[18px]" weight="regular" aria-hidden />
                </span>
                <div className="min-w-0">
                  <div className="text-type-body-sm font-semibold">{ben.title}</div>
                  <div className="type-label mt-0.5 leading-snug text-white/80">{ben.body}</div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </aside>
  );
}
